<app-sub-page [navBackRoute]="navBackRoute">
  <div class="flex column flex-1 width-100 gap-05" style="max-width: 800px">
    <div class="text-title" style="margin-left: 1rem">{{ pageTitle }}</div>
    <div class="flex column width-100 flex-1 gap-05">
      <form [formGroup]="monthDataForm" (ngSubmit)="save()">
        <div class="flex column width-100 flex-1 gap-1">
          <div class="bordered-container flex-center align-center">
            <div class="edit-time">
              <div class="flex flex-center" style="width: 80px; font-size: 1.2rem; font-weight: 600">
                {{ convertDataValue(monthData.vmax) }}
              </div>
              <div class="label">VMAX</div>
            </div>
            <div class="edit-time">
              <div class="flex flex-center" style="width: 80px; font-size: 1.2rem; font-weight: 600">
                {{ convertDataValue(monthData.proj) }}
              </div>
              <div class="label">PROJ</div>
            </div>
            <div class="edit-time">
              <div class="flex flex-center" style="width: 80px; font-size: 1.2rem; font-weight: 600">
                {{ convertDataValue(monthData.imax) }}
              </div>
              <div class="label">IMAX</div>
            </div>
          </div>
          <div class="bordered-container column">
            @for (input of monthDataInputs.dayInputs; track $index) {
            <div class="edit-days">
              <div class="label">{{ input.label }}</div>
              <input [formControlName]="input.formControlName" type="number" (keyup)="onKeyUp()" inputmode="numeric" />
            </div>
            }
            <div class="edit-days" style="border-top: 1px solid var(--surface-300); padding-top: 0.5rem">
              <div class="label">Required Credit</div>
              <div class="flex flex-center" style="width: 80px; font-size: 1.2rem; font-weight: 600">
                {{ requiredCredit }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <app-button
      class="width-100"
      label="Save Month Data"
      [outlined]="globalService.theme() == 'dark'"
      [disabled]="!unsavedChanges"
      (click)="save()"
    />
  </div>
</app-sub-page>
